import { useEffect, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import SidebarContent from "components/main/sidebar/components/SidebarContent";
import EdgeLogo from "components/Design/EdgeLogo/EdgeLogo";
import type { SidebarItem } from "plg/shell/usePlgMenuItems";

export interface PlgMobileNavProps {
  open: boolean;
  onClose: () => void;
  menuItems: SidebarItem[];
  stickyItems: SidebarItem[];
  userInfo: { name: string; companyName: string; email: string; avatar: ReactNode; subtitle: string };
  onMenuItemClick: (path: string, openInNewTab?: boolean) => void;
}

/**
 * Phones (below 600px): the sidebar is hidden there (the shared Sidebar shows no rail), so the header's menu button
 * opens the same menu in a drawer over the page. Kept inside the shell (disablePortal) for the PLG sidebar styles.
 */
function PlgMobileNav({ open, onClose, menuItems, stickyItems, userInfo, onMenuItemClick }: PlgMobileNavProps) {
  const location = useLocation();
  useEffect(() => {
    onClose();
    // Closes on any page change, also one made from the page behind it.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
  return (
    <Drawer variant="temporary" anchor="left" open={open} onClose={onClose} disablePortal className="plg-mobile-nav">
      <SidebarContent
        menuItems={menuItems}
        stickyItems={stickyItems}
        userInfo={userInfo}
        logo={<EdgeLogo size="md" state="light" />}
        location={location}
        onMenuItemClick={(path: string, openInNewTab?: boolean) => {
          if (path) onClose();
          onMenuItemClick(path, openInNewTab);
        }}
      />
    </Drawer>
  );
}

export default PlgMobileNav;
